// extracted by mini-css-extract-plugin
export var active = "_bg-2";
export var highlight = "_bg-1";
export var highlightLayer = "_bg-0";
export var issuePopover = "_bg-3";
export var statusIcon = "_bg-4";